import { useEffect, useRef } from 'react';
const {
  setIntervalAsync,
  clearIntervalAsync,
} = require('set-interval-async/dynamic');

export function useAsyncInterval(callback: () => Promise<void>, delay) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    savedCallback.current();
    if (delay !== null) {
      const id = setIntervalAsync(savedCallback.current, delay);
      return () => {
        clearIntervalAsync(id);
      };
    }
  }, [callback, delay]);
}
